/* MARIACHILL theme — front-end JS
   Lekki vanilla JS bez frameworka. Obsługuje:
   - Hero slider z auto-play
   - Cart drawer otwierany z ikony torby (uses Shopify /cart.js API)
   - Accordion sekcji
   - Filtry kolekcji (form submit on change)
*/

(function () {
  'use strict';

  /* ============== HERO SLIDER ============== */
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = slider.querySelectorAll('.hero-slide');
    const dots = slider.querySelectorAll('.hero-dot');
    const prev = slider.querySelector('[data-hero-prev]');
    const next = slider.querySelector('[data-hero-next]');
    const interval = parseInt(slider.dataset.interval || '5000', 10);
    let idx = 0;
    let timer;
    let paused = false;

    function show(i) {
      slides.forEach((s, n) => s.classList.toggle('active', n === i));
      dots.forEach((d, n) => d.classList.toggle('active', n === i));
      idx = i;
    }
    function go(i) { show((i + slides.length) % slides.length); restart(); }
    function restart() {
      clearTimeout(timer);
      if (paused || slides.length < 2) return;
      timer = setTimeout(() => go(idx + 1), interval);
    }
    if (prev) prev.addEventListener('click', () => go(idx - 1));
    if (next) next.addEventListener('click', () => go(idx + 1));
    dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
    slider.addEventListener('mouseenter', () => { paused = true; clearTimeout(timer); });
    slider.addEventListener('mouseleave', () => { paused = false; restart(); });
    show(0);
    restart();
  });

  /* ============== ACCORDION ============== */
  document.querySelectorAll('[data-accordion-item]').forEach((item) => {
    const head = item.querySelector('[data-accordion-head]');
    if (!head) return;
    head.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      // optional: close siblings
      item.parentElement.querySelectorAll('[data-accordion-item]').forEach((s) => s.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ============== CART DRAWER (Shopify AJAX) ============== */
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawerBody = document.querySelector('[data-cart-body]');
  const drawerFoot = document.querySelector('[data-cart-foot]');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function updateCartUI(cart) {
    cartCountEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (!drawerBody) return;
    if (cart.item_count === 0) {
      drawerBody.innerHTML = `
        <div class="cart-empty">
          <h3>Koszyk jest pusty</h3>
          <p>Dodaj pierwszy produkt, żeby tu coś się pojawiło.</p>
          <a class="btn btn-primary" style="margin-top: 20px" href="/collections/all">Przejdź do sklepu</a>
        </div>`;
      drawerFoot.style.display = 'none';
    } else {
      drawerBody.innerHTML = cart.items.map(it => `
        <div class="cart-row" data-key="${it.key}">
          <div class="cart-thumb">
            ${it.image ? `<img src="${it.image}" alt="${it.title}" style="width:100%;height:100%;object-fit:cover" />` : ''}
          </div>
          <div>
            <div class="cart-row-name">${it.product_title}</div>
            <div class="cart-row-meta">${it.variant_title || ''}</div>
            <div class="cart-row-bottom">
              <div class="cart-qty">
                <button data-qty="-" data-key="${it.key}">−</button>
                <span>${it.quantity}</span>
                <button data-qty="+" data-key="${it.key}">+</button>
              </div>
            </div>
            <span class="cart-remove" data-remove="${it.key}">Usuń</span>
          </div>
          <div class="cart-row-price">${moneyFormat(it.final_line_price)}</div>
        </div>
      `).join('');

      drawerFoot.style.display = '';
      const cfg = window.MC || {};
      const free = cart.total_price >= (cfg.freeShip || 20000);
      const shipping = free ? 0 : (cfg.flatShip || 1490);
      drawerFoot.innerHTML = `
        <div class="cart-summary-row"><span>Wartość produktów</span><span>${moneyFormat(cart.total_price)}</span></div>
        <div class="cart-summary-row"><span>Dostawa</span><span>${free ? 'GRATIS' : moneyFormat(shipping)}</span></div>
        <div class="cart-summary-row total"><span>Razem</span><span class="num">${moneyFormat(cart.total_price + shipping)}</span></div>
        <a href="/checkout" class="btn btn-primary btn-lg" style="width:100%;margin-top:18px">Przejdź do kasy</a>
        <button class="btn btn-ghost" style="width:100%;margin-top:8px" data-cart-close>Kontynuuj zakupy</button>
      `;
    }
  }

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  async function changeQty(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    return r.json();
  }

  // Bez szuflady: krotkie potwierdzenie dodania do koszyka
  let toastTimer = null;
  function openDrawer() {
    let t = document.querySelector('.mc-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'mc-toast';
      t.innerHTML = '<span>Dodano do koszyka</span><a href="/cart">Przejdź do koszyka</a>';
      document.body.appendChild(t);
    }
    requestAnimationFrame(() => t.classList.add('on'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('on'), 4000);
  }
  function closeDrawer() {
    const t = document.querySelector('.mc-toast');
    if (t) t.classList.remove('on');
  }

  // Koszyk staly: ikona torby prowadzi na /cart, bez szuflady.
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-close]')) closeDrawer();
  });

  // Drawer body delegation: qty change + remove
  if (drawerBody) {
    drawerBody.addEventListener('click', async (e) => {
      const qtyBtn = e.target.closest('[data-qty]');
      const removeBtn = e.target.closest('[data-remove]');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const dir = qtyBtn.dataset.qty;
        const row = drawerBody.querySelector(`[data-key="${key}"] .cart-qty span`);
        const current = parseInt(row.textContent, 10);
        const target = dir === '+' ? current + 1 : Math.max(0, current - 1);
        const cart = await changeQty(key, target);
        updateCartUI(cart);
      }
      if (removeBtn) {
        const cart = await changeQty(removeBtn.dataset.remove, 0);
        updateCartUI(cart);
      }
    });
  }

  // Add to cart from product card or product form
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    await fetch('/cart/add.js', { method: 'POST', body: formData });
    const cart = await fetchCart();
    updateCartUI(cart);
    openDrawer();
  });

  // Quick add buttons on product cards
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.quickAdd;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetchCart();
      updateCartUI(cart);
      openDrawer();
    } catch (err) {
      console.error('Nie udalo sie dodac do koszyka', err);
    } finally {
      btn.disabled = false;
    }
  });

  // Product detail: qty selector
  document.querySelectorAll('[data-qty-control]').forEach((wrap) => {
    const input = wrap.querySelector('input[name="quantity"]');
    wrap.querySelector('[data-qty-minus]').addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Product variant picker
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const form = picker.closest('form');
    const idInput = form.querySelector('input[name="id"]');
    const variants = JSON.parse(picker.dataset.variants || '[]');
    function syncVariant() {
      const selected = {};
      picker.querySelectorAll('.pd-opts').forEach((group) => {
        const optName = group.dataset.option;
        const active = group.querySelector('.pd-opt.active');
        if (active) selected[optName] = active.dataset.value;
      });
      const match = variants.find(v => Object.keys(selected).every(k => v.options[k] === selected[k]));
      if (match) {
        idInput.value = match.id;
        const priceEl = document.querySelector('[data-product-price]');
        if (priceEl) priceEl.textContent = moneyFormat(match.price);
      }
    }
    picker.querySelectorAll('.pd-opt').forEach((opt) => {
      opt.addEventListener('click', () => {
        const group = opt.parentElement;
        group.querySelectorAll('.pd-opt').forEach(o => o.classList.remove('active'));
        opt.classList.add('active');
        syncVariant();
      });
    });
  });

})();
